<template>
    <div class="ngdialog-content">
        <dialog-header>
            <h4>{{ $t('labels.add') }}</h4>
        </dialog-header>

        <form name="labelsForm" novalidate @submit.prevent="submitHandler" class="form">
            <div class="ngdialog__body">
                <fieldset class="form__group">
                    <div class="row form__row">
                        <label class="form__label" for="label">{{ $t('fields.label') }}</label>
                        <el-select
                            v-model="formData.label_id"
                            filterable
                            :allow-create="$can('manage', 'System labels')"
                            default-first-option
                            :class="{
                                'is-invalid': $v.formData.label_id.$invalid,
                                'is-dirty': $v.formData.label_id.$dirty,
                            }"
                        >
                            <el-option
                                v-for="o in labels"
                                :key="o.id"
                                :value="o.id"
                                :label="o.name"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="row form__row">
                        <label class="form__label" for="label">{{
                            $t('fields.organization')
                        }}</label>
                        <el-select v-model="formData.organization_id" filterable>
                            <el-option
                                v-for="o in organizations"
                                :key="o.id"
                                :value="o.id"
                                :label="o.name"
                            ></el-option>
                        </el-select>
                    </div>
                </fieldset>
            </div>

            <dialog-buttons :submit-text="$t('buttons.save')" :disabled="loading" />
        </form>
    </div>
</template>

<script>
import * as api from '@/api';
import DialogHeader from '@/components/DialogHeader';
import DialogButtons from '@/components/DialogButtons';
import { required } from 'vuelidate/lib/validators';

export default {
    components: {
        DialogHeader,
        DialogButtons,
    },
    props: {
        systemId: {
            type: [Boolean, String],
            default: false,
        },
        organizations: {
            type: [Boolean, Array],
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            labels: [],
            formData: {
                label_id: '',
                organization_id: '',
            },
        };
    },
    validations() {
        return {
            formData: {
                label_id: {
                    required,
                },
                organization_id: {
                    required,
                },
            },
        };
    },
    mounted() {
        this.loadPredefinedLabels();
        this.formData.organization_id = this.organizations[0].id;
    },
    methods: {
        submitHandler() {
            if (this.$v.formData.$invalid) {
                this.$v.formData.$touch();
                return;
            }
            const labelExists = this.labels.filter(label => label.id === this.formData.label_id);
            if (labelExists && labelExists.length > 0) {
                this.addLabel();
            } else {
                this.createLabel();
            }
        },
        async loadPredefinedLabels() {
            try {
                const response = await api.labels.all();
                this.labels = response.data.labels;
            } catch (error) {
                console.error(error);
            }
        },
        async createLabel() {
            this.loading = true;
            try {
                const response = await api.labels.create({
                    name: this.formData.label_id,
                });
                if (response && response.data) {
                    this.formData.label_id = response.data.id;
                    this.addLabel();
                }
            } catch (error) {
                console.error(error);
                this.$notify({
                    type: 'error',
                    text: this.$t('labels.error_create_label'),
                });
            }
        },
        async addLabel() {
            this.loading = true;
            try {
                const response = await api.labels.add(this.systemId, this.formData);
                if (response) {
                    this.loading = false;
                    this.$emit('close');
                    this.$notify({
                        type: 'success',
                        text: this.$t('labels.success_add_label'),
                    });
                }
            } catch (error) {
                console.error(error);
                this.$notify({
                    type: 'error',
                    text: this.$t('labels.error_add_label'),
                });
            }
        },
    },
};
</script>
